<script>
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import FormPasswordBox from "../../../atoms/FormPasswordBox.vue";

export default {
  name: 'BCOptionalFeaturesPassword',
  components: {FormPasswordBox, SettingGroup, SettingItem },
  data() {
    // フォームモデル
    const form = {
      password: {
        transceiverPassword: null,
        extendedMenuPassword: null,
        prevTransceiverPassword: null,
        prevExtendedMenuPassword: null,
      },
    }

    // バリデーション関数（6桁までの数字のみ）
    const validateTransceiverPassword = (_rule, value, callback) => {
      const prev = this.form.password.prevTransceiverPassword || ''
      const diff = String(value || '').replace(prev, '')
      const regex = /^(?:[0-9]{0,6})$/
      if (!regex.test(String(this.form.password.transceiverPassword || '')) && diff) {
        this.form.password.transceiverPassword = String(this.form.password.transceiverPassword || '').slice(0, -1 * diff.length)
      }
      this.form.password.prevTransceiverPassword = this.form.password.transceiverPassword
      callback()
    }
    const validateExtendedMenuPassword = (_rule, value, callback) => {
      const prev = this.form.password.prevExtendedMenuPassword || ''
      const diff = String(value || '').replace(prev, '')
      const regex = /^(?:[0-9]{0,6})$/
      if (!regex.test(String(this.form.password.extendedMenuPassword || '')) && diff) {
        this.form.password.extendedMenuPassword = String(this.form.password.extendedMenuPassword || '').slice(0, -1 * diff.length)
      }
      this.form.password.prevExtendedMenuPassword = this.form.password.extendedMenuPassword
      callback()
    }

    const rules = {
      transceiverPassword: [{ validator: validateTransceiverPassword, trigger: 'change' }],
      extendedMenuPassword: [{ validator: validateExtendedMenuPassword, trigger: 'change' }],
    }

    return {
      radioSettings: null,
      setting: null,
      form,
      rules,
    }
  },
  created() {
    // ストアに仮保存済みの端末設定情報を取得する
    this.radioSettings = useRadioSettingsStore()
    this.setting = this.radioSettings.getTempSetting()
    this.transSetting2Form()
  },
  watch: {
    form: {
      handler() {
        // 端末設定へ反映
        this.transForm2Setting()
        // 仮保存へ反映
        this.radioSettings.saveTempSetting(this.setting)
      },
      deep: true,
    },
  },
  methods: {
    sanitizePasswordInput(val) {
      // ASCII の半角数字 (U+0030〜U+0039) のみ許容し、最大 6 桁に丸める
      const s = String(val ?? '')
      const sanitized = s.replace(/[^\u0030-\u0039]/g, '').slice(0, 6)
      return sanitized || null
    },
    transForm2Setting() {
      const data = this.setting.OptionalFeatures.Password
      // デバッグログ
      console.log('============================')
      try {
        console.log('before setting: ', JSON.parse(JSON.stringify(this.setting.OptionalFeatures.Password)))
      } catch (e) {}
      data.TransceiverPassword = this.form.password.transceiverPassword || null
      data.ExtendedMenuPassword = this.form.password.extendedMenuPassword || null
      try {
        console.log('after setting: ', JSON.parse(JSON.stringify(this.setting.OptionalFeatures.Password)))
      } catch (e) {}
    },
    transSetting2Form() {
      const data = this.setting.OptionalFeatures.Password
      // デバッグログ
      console.log('============================')
      try {
        console.log('before form: ', JSON.parse(JSON.stringify(this.form)))
      } catch (e) {}
      this.form.password.transceiverPassword = data.TransceiverPassword
      this.form.password.extendedMenuPassword = data.ExtendedMenuPassword
      try {
        console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
      } catch (e) {}
    },
  },
}
</script>

<template>
  <SettingGroup>
    <SettingItem label="無線機パスワード">
      <el-form :model="form.password" :rules="rules">
        <el-form-item prop="transceiverPassword">
            <FormPasswordBox
                :inputValue="form.password.transceiverPassword"
                @update:inputValue="val => (form.password.transceiverPassword = sanitizePasswordInput(val))"
                :showPassword="true"
                :maxLength="6"
                placeholder="6桁までの数字"
            />
        </el-form-item>
      </el-form>
    </SettingItem>
    <SettingItem label="拡張メニュー・パスワード">
      <el-form :model="form.password" :rules="rules">
        <el-form-item prop="extendedMenuPassword">
            <FormPasswordBox
                :inputValue="form.password.extendedMenuPassword"
                @update:inputValue="val => (form.password.extendedMenuPassword = sanitizePasswordInput(val))"
                :showPassword="true"
                :maxLength="6"
                placeholder="6桁までの数字"
            />
        </el-form-item>
      </el-form>
    </SettingItem>
  </SettingGroup>
</template>
